var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9908 18.9106L20.3184 24.6216H19.0816L18.3926 18.9106V15.8062H20.9908V18.9106ZM20.9244 25.6011V28H18.4507V25.6011H20.9244Z",
    fill: "#D4351C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5739 2.26202L34.9176 33.3941L4.23012 33.3941L19.5739 2.26202Z",
    stroke: "#D4351C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyIcon);
export default __webpack_public_path__ + "static/media/emergency-icon.de59bffde629dee9a24c8bc6391ea89b.svg";
export { ForwardRef as ReactComponent };